import { getLastDocumentByCandidateIdAndDocumentTypeQuery } from 'store/manager-document/manager-document.interface';
import { apiService, driverTag } from 'store/api';
import { FetchBaseQueryMeta } from '@reduxjs/toolkit/query';

export const managerDocumentService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getLastDocumentByCandidateIdAndDocumentType: builder.query<
      getLastDocumentByCandidateIdAndDocumentTypeQuery['response'] | undefined,
      getLastDocumentByCandidateIdAndDocumentTypeQuery['request']
    >({
      query: ({ candidateId, documentType }) => ({
        url: `/document/manager/get-last-one/${candidateId}/${documentType}`,
        method: 'GET',
        validateStatus: (response) => response.ok || response.status === 404,
      }),
      transformResponse: (response, meta) =>
        (meta as FetchBaseQueryMeta)?.response?.status === 404
          ? undefined
          : (response as getLastDocumentByCandidateIdAndDocumentTypeQuery['response']),
      providesTags: [driverTag],
    }),
  }),
});
